import AlertDayOfMonth, { AlertDayOfMonthStrings } from 'enums/AlertDayOfMonth'
import AlertFrequency, { AlertFrequencyStrings } from 'enums/AlertFrequency'
import i18n from 'i18n'

export const scheduledReportFrequencyString = (frequency: AlertFrequencyStrings) => {
  const frequencyStringMap: Record<string, string> = {
    [AlertFrequency.DAILY]: 'daily',
    [AlertFrequency.MONTHLY]: 'monthly',
    [AlertFrequency.TWICE_DAILY]: 'twiceDaily',
    [AlertFrequency.WEEKLY]: 'weekly'
  }
  return frequency && i18n.t(frequencyStringMap[frequency])
}

export const scheduledReportAlertDayOfMonthString = (alertDayOfMonth?: AlertDayOfMonthStrings) => {
  const alertDayOfMonthStringMap: Record<string, string> = {
    [AlertDayOfMonth.FIRST]: 'firstOfMonth',
    [AlertDayOfMonth.FIFTEENTH]: 'fifteenthOfMonth',
    [AlertDayOfMonth.LAST]: 'lastDayOfMonth'
  }
  return alertDayOfMonth && i18n.t(alertDayOfMonthStringMap[alertDayOfMonth])
}
